module.exports = __webpack_public_path__ + "img/p18.f0d8281d.png";